const config = {
  site: {
    title: "API docs",
    logo: {
      src: { light: "/MBLOGO.svg", dark: "/MBLOGO.svg" },
      alt: "MarketBox Inc",
      width: "200px",
    },
    footer: {
      copyright: `© ${new Date().getFullYear()} MarketBox, Inc. All rights reserved.`,
      logo: {
        src: { light: "/MBLOGO.svg", dark: "/MBLOGO.svg" },
        alt: "MarketBox Inc",
        width: "130px",
      },
    },
  },
  metadata: {
    title: "%s | MarketBox API",
    defaultTitle: "MarketBox API Documentation",
    favicon: "/mbfavicon.svg",
    logo: "/MBLOGO.svg",
    keywords: [
      "availability intelligence",
      "api",
      "marketbox",
      "scheduling",
      "booking",
      "smart clusters",
      "clusters",
      "integration",
    ],
    publisher: "MarketBox Inc.",
  },
  navigation: [
    {
      type: "category",
      label: "OVERVIEW",
      items: [
        "overview",
        {
          type: "category",
          label: "Common use cases",
          link: "use-cases",
          items: [
            "usecases/ai-chatbot-booking",
            "usecases/ai-voiceagent-booking",
            "usecases/website-timeslot-display",
            "usecases/provider-profiles",
            "usecases/custom-booking-flow",
            "usecases/enhance-booking-flow",
            "usecases/dispatcher-operations",
            "usecases/field-sales",
            "usecases/waitlist",
            "usecases/rescheduling",
          ],
        },
        "what-smart-clusters-replaces",
        "what-smart-clusters-integrates-with",
        "industries",
        "integration-options",
        "integration-mistakes",
        {
          type: "category",
          label: "Webhooks",
          link: "webhooks/index",
          items: [
            "webhooks/receiving-events",
            "webhooks/event-schemas",
          ],
        },
        "api-reference",
      ],
    },
    {
      type: "link",
      icon: "square-library",
      to: "/api-documentation",
      label: "API DOCUMENTATION",
    },
  ],
  redirects: [{ from: "/", to: "/overview" }],
  apis: [
    {
      type: "file",
      input: "./apis/mbapispec.json",
      path: "/api-documentation",
      categories: [
        {
          label: "General",
          tags: ["API DOCUMENTATION"],
        },
      ],
    },
  ],
  search: {
    type: "pagefind",
    maxSubResults: 3,
    ranking: {
      termFrequency: 0.8,
      pageLength: 0.6,
      termSimilarity: 1.2,
      termSaturation: 1.2,
    },
  },
  theme: {
    light: {
      background: "oklch(100% 0 none)",
      foreground: "oklch(14.7% 0.004 49.3)",
      card: "oklch(100% 0 none)",
      cardForeground: "oklch(14.7% 0.004 49.3)",
      popover: "oklch(100% 0 none)",
      popoverForeground: "oklch(14.7% 0.004 49.3)",
      //  primary: "oklch(70.5% 0.187 47.6)",
      primary: "oklch(0.6634 0.1531 248.91)",
      primaryForeground: "oklch(98.5% 0.001 106)",
      secondary: "oklch(97% 0.001 106)",
      secondaryForeground: "oklch(21.6% 0.006 56)",
      muted: "oklch(97% 0.001 106)",
      mutedForeground: "oklch(55.3% 0.012 58.1)",
      accent: "oklch(97% 0.001 106)",
      accentForeground: "oklch(21.6% 0.006 56)",
      destructive: "oklch(63.7% 0.208 25.3)",
      destructiveForeground: "oklch(98.5% 0.001 106)",
      border: "oklch(92.3% 0.003 48.7)",
      input: "oklch(92.3% 0.003 48.7)",
      ring: "oklch(70.5% 0.187 47.6)",
      radius: "0.6rem",
    },
    dark: {
      background: "oklch(14.7% 0.004 49.3)",
      foreground: "oklch(98.5% 0.001 106)",
      card: "oklch(14.7% 0.004 49.3)",
      cardForeground: "oklch(98.5% 0.001 106)",
      popover: "oklch(14.7% 0.004 49.3)",
      popoverForeground: "oklch(98.5% 0.001 106)",
      //primary: "oklch(64.5% 0.194 41.1)", //mb orange
      primary: "oklch(0.6634 0.1531 248.91)", //mb blue
      primaryForeground: "oklch(98.5% 0.001 106)",
      secondary: "oklch(26.9% 0.006 34.3)",
      secondaryForeground: "oklch(98.5% 0.001 106)",
      muted: "oklch(26.9% 0.006 34.3)",
      mutedForeground: "oklch(71.6% 0.009 56.3)",
      accent: "oklch(26.9% 0.006 34.3)",
      accentForeground: "oklch(98.5% 0.001 106)",
      destructive: "oklch(57.7% 0.215 27.3)",
      destructiveForeground: "oklch(98.5% 0.001 106)",
      border: "oklch(26.9% 0.006 34.3)",
      input: "oklch(26.9% 0.006 34.3)",
      ring: "oklch(64.5% 0.194 41.1)",
      radius: "0.6rem",
    },
  },
  defaults: {
    apis: {
      examplesLanguage: "js",
      schemaDownload: {
        enabled: true,
      },
      expandApiInformation: true,
    },
  },
  docs: {
    publishMarkdown: true,
    llms: {
      llmsTxt: true,
      llmsTxtFull: true,
    },
  },
  sitemap: {
    siteUrl:
      process.env.ZUDOKU_PUBLIC_SITE_URL ||
      "https://dev.d3k5xu03huf9gt.amplifyapp.com",
    changefreq: "weekly",
    priority: 0.8,
    autoLastmod: true,
  },
};

export default config;
